"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KicadComponentResolver = void 0;
const Util_1 = require("../../Util");
class KicadComponentResolver {
    constructor(project, resolutionOpts = {}) {
        this.project = project;
        this.resolutionOpts = resolutionOpts;
        this.componentMap = new Map();
        this.nextSequentialNameMap = new Map();
    }
    addComponentPart(module) {
        this.componentMap.set(module.ref, module.componentRef);
    }
    getComponentForFootprint(module, footprint, model) {
        if (module) {
            const path = this.formatIdentifier(module);
            if (this.componentMap.has(path)) {
                const componentRef = this.componentMap.get(path);
                if (this.project.components[componentRef]) {
                    return this.project.components[componentRef];
                }
                else {
                    model.warnings.push(`Did not resolve component for component ref ${componentRef} in fp ${path}`);
                }
            }
            else {
                model.warnings.push(`Did not resolve component for footprint path: ${path}`);
            }
        }
        return (0, Util_1.findComponentByFootprint)(this.project, footprint, model);
    }
    formatIdentifier(module) {
        return module.ref;
    }
    getNextSequentialName(designId, pattern, leftPad = 3) {
        if (!this.nextSequentialNameMap.has(pattern)) {
            this.nextSequentialNameMap.set(pattern, 1);
        }
        const nextName = this.nextSequentialNameMap.get(pattern);
        this.nextSequentialNameMap.set(pattern, nextName + 1);
        return this.validateAnnotatedName(designId, `${pattern}${nextName.toString().padStart(leftPad, '0')}`);
    }
    validateAnnotatedName(_designId, moduleName) {
        return moduleName;
    }
    validateSourceModuleName(_designId, moduleName, _moduleRef) {
        return moduleName;
    }
    validateSourceNetName(_designId, netName, _type) {
        return netName;
    }
    validateSourceModuleRef(_designId, ref) {
        return ref;
    }
    updateAltiumSupplySymbol(component) {
        if (this.isPowerFlag(component.metadata)) {
            return { ...component, isVirtual: true };
        }
        return component;
    }
    isPowerFlag(metadata) {
        return metadata?.['ki_keywords'] === 'power-flag';
    }
}
exports.KicadComponentResolver = KicadComponentResolver;
//# sourceMappingURL=ComponentResolver.js.map